<template>
  <div class="ac2" style="width: 100%">
    <!-- banner -->
    <div class="banner" style="width: 100%">
      <img src="/imgs/ct.jpg" style="width: 100%" />
    </div>
    <!-- 顶宽布局 -->
    <div class="container">
      <!-- 标题 -->
      <div class="a2-title">
        <h3>关于我们</h3>
        <div class="blink"></div>
      </div>
      <!-- 容器 -->
      <div class="a2-con">
        <div class="a2-l">
          <div class="a2-box">
            <p>
              北京蓝色奥义科技有限公司成立于2023年02月28日，注册地位于北京市海淀区畅茜园雪芳里6号楼1层102-A407
            </p>
            <p>
              经营范围包括一般项目：技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；信息系统集成服务；计算机系统服务；软件开发；人工智能基础软件开发；人工智能应用软件开发；软件销售；专业设计服务；广告发布；广告设计、代理；计算机软硬件及辅助设备批发；计算机软硬件及辅助设备零售；数据处理服务；
            </p>
            <p>
              技术进出口；货物进出口；进出口代理。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）许可项目：基础电信业务；互联网信息服务；第二类增值电信业务；网络文化经营；演出经纪；广播电视节目制作经营；出版物零售；出版物批发。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）（不得从事国家和本市产业政策禁止和限制类项目的经营活动。）
            </p>
          </div>
        </div>
        <div class="a2-r"></div>
      </div>
      <!-- 文本区 -->
      <!-- <div class="a2-info">
      
        <div class="a2-item">
          <h3>联系我们:</h3>
          <p>公司名称：北京贝塔科技有限公司</p>
          <p>公司电话：010- 62927872</p>
        
          <p>网站域名：bettaer.com</p>
          <p>公司地址：北京市海淀区西小口路66号中关村东升科技园B6号楼C座3-4层/A座5层</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css";

export default {
  name: "ac1",
  components: {},
  data() {
    return {};
  },
  mounted() {
    document.title = "北京蓝色奥义科技有限公司";
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.ac2 {
  .banner {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
    margin-top: 80px;
  }

  .container {
    // height: 1000px;
    margin: 60px auto;
    padding-top: 30px;
    box-sizing: border-box;

    // 标题
    .a2-title {
      text-align: center;

      h3 {
        font-size: 21px;
        color: #00bfb0;
      }

      .blink {
        width: 250px;
        height: 1px;
        background-color: #00bfb0;
        margin: 5px auto;
      }
    }

    // 容器
    .a2-con {
      width: 100%;
      height: 500px;
      //   background-color: pink;
      box-sizing: border-box;
      @include flex();

      // 左侧
      .a2-l {
        width: 50%;
        height: 100%;
        // background-color: red;
        position: relative;

        .a2-box {
          width: 80%;
          height: 80%;
          background-color: #4b80b7;
          position: absolute;
          right: 0;
          top: 50px;
          color: #fff;
          padding: 20px;
          box-sizing: border-box;

          p {
            font-size: 14px;
            margin: 25px auto;
          }
        }
      }

      // 右侧
      .a2-r {
        width: 50%;
        height: 100%;
        // background-color: yellow;
        background: url("/imgs/us.jpg") no-repeat center;
        background-size: cover;
      }
    }

    // 文本区
    .a2-info {
      .a2-item {
        margin-bottom: 60px;

        h3 {
          font-size: 24px;
          margin-bottom: 10px;
        }

        p {
          font-size: 14px;
          margin: 10px auto;
        }
      }
    }
  }
}</style>
